<script>
  import { Pagination, Autoplay } from 'swiper';
  import { Swiper, SwiperSlide } from 'swiper/svelte';

  import ImgOne from '$lib/assets/images/swipe1.jpg';
  import ImgTwo from '$lib/assets/images/swipe2.jpg';
  // import ImgThree from '$lib/assets/images/swipe3.jpg';

  // Import Swiper styles
  import 'swiper/css';
  import 'swiper/css/pagination';
  import 'swiper/css/autoplay';

  const swipeImgs = [ImgOne, ImgTwo];
</script>

<style>
  .swipe-img {
    max-width: 100%;
    height: auto;
  }
</style>

<div class="swipe-holder">
  <Swiper
    modules={[Pagination, Autoplay]}
    centeredSlides={true}
    spaceBetween={0}
    slidesPerView={1}
    navigation
    pagination={{ clickable: true }}
    autoplay={{ delay: 5000 }}
  >
    {#each swipeImgs as img}
      <SwiperSlide>
        <img class="swipe-img" src={img} alt="swipe-img">
      </SwiperSlide>
    {/each}
  </Swiper>
</div>
